/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Returnairhumiditysetpoint3Inputs */



/**
* | output |
* | --- |
* | "Return air humidity setpoint" |
*
* @param {Ahu_History_Key_Returnairhumiditysetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_returnairhumiditysetpoint3 = /** @type {((inputs?: Ahu_History_Key_Returnairhumiditysetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Returnairhumiditysetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Return air humidity setpoint")
	return /** @type {LocalizedString} */ ("Consigne humidité air reprise")
});
export { ahu_history_key_returnairhumiditysetpoint3 as "ahu_history_key_returnAirHumiditySetpoint" }